import { render, staticRenderFns } from "./PushAlerts.vue?vue&type=template&id=0939be1e&"
import script from "./PushAlerts.vue?vue&type=script&lang=js&"
export * from "./PushAlerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports